import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/profesores';
import ProfesorCrear from './ProfesorCrear';


const ms2p = (state) => {
  return {
    ...state.profesores,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ProfesorCrear);
